import app from '../main'

export default function displayError (error) {
  console.log(error)
  if (error.response.status === 422) {
    app.$snotify.error(capitalizeFirstLetter(Object.keys(error.response.data.errors)[0]) + ' ' + error.response.data.errors[Object.keys(error.response.data.errors)[0]])
  } else if (error.response.status === 401 || error.response.status === 403) {
    app.$snotify.error(error.response.data.errors[Object.keys(error.response.data.errors)[0]])
  } else {
    app.$snotify.error('An error occurred, please try again.')
  }
}

function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}



// WEBPACK FOOTER //
// ./src/helpers/displayError.js